import { NgModule } from '@angular/core';
import { NgTimepickerComponent } from './timepicker/ng-timepicker.component';
import { ScrollColumnComponent } from './scroll-column/scroll-column.component';

@NgModule({
  imports: [NgTimepickerComponent, ScrollColumnComponent],
  exports: [NgTimepickerComponent, ScrollColumnComponent],
})
export class NgTimepickerModule {}
